
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1599184757190",
    "class": "icon",
    "viewBox": "0 0 1027 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1064",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M790.62826087 316.98369565a274.54891304 274.54891304 0 1 1-549.09782609 0 274.54891304 274.54891304 0 0 1 549.09782609 0z m-47.95434783 287.4326087a364.79347826 364.79347826 0 0 1-226.59456521 78.56413043c-84.28695652 0-164.34782609-28.70217391-228.61956522-80.17826087C118.06413043 664.99021739 42.40543478 882.31086957 42.40543478 981.56521739h942.53478261c0-98.37391304-76.24565217-314.16847826-242.29565217-377.11956522z",
        "p-id": "1065"
      }
    }
  ]
})
    }
  